import { InMemoryLeadsRepository } from "../../../../../test/repositories/inMemoryLeadsRepository"
import { makeLead } from "../../../../../test/factories/makeLead"
import { IFetchLeadsByOriginNameProtocol } from "../../protocols/leads/IFetchLeadsByOriginNameProtocol"
import { FetchLeadsByOriginNameUseCase } from "./fetchLeadsByOriginName"
import { randomUUID } from "node:crypto"
import { InMemoryOriginsRepository } from "test/repositories/inMemoryOriginsRepository"
import { makeOrigin } from "test/factories/makeOrigin"
import { OrderBy, OrderType } from "../../protocols/leads/enums/Order"

let sut: IFetchLeadsByOriginNameProtocol
let repository: InMemoryLeadsRepository
let originsRepositoty: InMemoryOriginsRepository

describe('Fetch Leads By Origin Name', () => {
  beforeEach(()=>{
    originsRepositoty = new InMemoryOriginsRepository()
    repository = new InMemoryLeadsRepository(originsRepositoty)
    sut = new FetchLeadsByOriginNameUseCase(repository)
  })

  it('Should be able to fetch leads by origin', async ()=> {
    const originOnDatabase = makeOrigin({
      name: 'Unit Test'
    })
    await originsRepositoty.create(originOnDatabase)

    for (let i = 1; i <= 8; i++) {
      repository.items.push(makeLead({
        email: `email${i}@mail.com`,
        originId: originOnDatabase.id
      }))
    }

    const {leads, nextPage, totalPages, perPage} = await sut.execute({
      originName: 'Unit Test',
      limit: 5, 
      orderBy: OrderBy.EMAIL, 
      orderType: OrderType.ASC, 
      page: 2
    })

    expect(leads.length).toEqual(3)
    expect(leads[0].email).toEqual('email6@mail.com')
    expect(nextPage).toBeNull()
    expect(totalPages).toEqual(2)
    expect(perPage).toEqual(5)
  })
})